import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { media } from '../../services/media';

import { IconRawSvg } from '../IconRawSvg';

export const ContactForm = styled.form`
    text-align: center;
    width: 100%;
`;

export const ContactFormHeading = styled.h3`
    font-size: 20px;

    ${media.max('md')} {
        margin: 0 0 10px;
    }

    ${media.min('md')} {
        margin: 0 0 20px;
    }
`;

export const FormLabel = styled.label`
    display: flex;
    text-align: left;
    font-size: 16px;

    ${media.max('md')} {
        margin: 0 0 10px;
    }

    ${media.min('md')} {
        margin: 0 0 20px;
    }
`;

export const FormInput = styled.input`
    border-bottom: 2px solid #ffffff;
    flex: 0 1 auto;
    color: #ffffff;
    width: 100%;

    ${media.min('xxl')} {
        border-width: 4px;
    }

    &::placeholder {
        color: inherit;
    }
`;

export const FormTextarea = styled.textarea`
    background-color: rgba(255, 255, 255, 0.2);
    text-align: left;
    font-weight: 400;
    border-radius: 5px;
    padding: 20px;
    margin: 0 0 20px;
    font-size: 16px;
    resize: none;
    border: 0;
    color: #ffffff;
    width: 100%;

    font-family: inherit;

    &:focus {
        outline: none;
    }

    ${media.max('md')} {
        height: 132px;
    }

    ${media.between('md', 'xl')} {
        height: 156px;
    }

    ${media.between('xl', 'xxl')} {
        height: 170px;
    }

    ${media.min('xxl')} {
        height: 14.9vw;
    }
`;

export const ClosePopupButton = styled.button`
    position: absolute;
    right: 28px;
    font-size: 18px;
    top: 22px;
    z-index: 99;
    cursor: pointer;
    outline: none;

    ${media.min('md')} {
        display: none;
    }
`;

export const PopupHeading = styled.h2`
    font-weight: 400;

    ${media.max('xl')} {
        font-size: 24px;
        margin: 0 0 25px;
    }

    ${media.min('xl')} {
        font-size: 48px;
        margin: 0 0 50px;
    }
`;

export const PopupFooter = styled.footer`
    position: relative;

    ${media.max('xl')} {
        font-size: 16px;
        margin: 24px 0 0 0;
    }

    ${media.min('xl')} {
        font-size: 26px;
        margin-top: 50px;
    }
`;

export const PopupFooterArrow = styled(IconRawSvg)`
    display: block;
    width: 27px;
    height: 66px;
    position: absolute;
    bottom: 130%;
    left: 83%;

    ${media.min('md')} {
        width: 31px;
        height: 74px;
    }

    ${media.min('xl')} {
        width: 62px;
        height: 153px;
    }

    svg {
        height: 100%;
    }
`;

const PopupWrapperPengestryke = css`
    background-color: #c44601;
    color: #ffffff;
`;

export const PopupWrapper = styled.div`
    position: relative;
    z-index: 1;
    text-align: center;
    max-width: 320px;
    margin: 0 auto;
    padding: 15px;
    max-width: 100%;

    ${(props) =>
        props.theme.version === 'pengestyrke' && PopupWrapperPengestryke}

    ${media.max('md')} {
        width: 380px;
    }

    ${media.between('md', 'xxl')} {
        width: 550px;
    }

    ${media.min('xxl')} {
        width: 670px;
    }
`;
